var supportDescriptors = require('core-js/internals/descriptors');
var defineProperty = require('core-js/internals/object-define-property').f;
var NAME = 'closest';
var proto = Element.prototype;

// https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
if (supportDescriptors && !proto.hasOwnProperty(NAME)) {
  var matches = proto.matches || proto.msMatchesSelector || proto.webkitMatchesSelector;
  defineProperty(proto, NAME, {
    configurable: true,
    value: function(selectors) {
      var element = this;

      do {
        if (matches.call(element, selectors)){
          return element;
        }

        // go up
        element = element.parentElement || element.parentNode;
      } while (element !== null && element.nodeType === 1);

      return null;
    }
  });
}
